export default "/images/vendor/flag-icon-css/flags/4x3/fk.svg?ddc6bd174c1e6603e32352cbbb63f3fb";